import {useLayoutEffect, useRef, useState} from 'react';

/**
 * Whether an element fits inside its parent's width, re-checked as the parent
 * resizes (window, rail, data). Assumes it fits where it can't measure.
 * Hide the element with `visibility` rather than unmounting it, so it stays
 * measurable.
 */
export const useFitsParent = <T extends HTMLElement>(content: string) => {
  const ref = useRef<T>(null);
  const [fits, setFits] = useState(true);
  useLayoutEffect(() => {
    const element = ref.current;
    const parent = element?.parentElement;
    if (!element || !parent || typeof ResizeObserver === 'undefined') return;
    const check = () => setFits(element.scrollWidth <= parent.clientWidth);
    check();
    const observer = new ResizeObserver(check);
    observer.observe(parent);
    return () => observer.disconnect();
  }, [content]);
  return {ref, fits};
};
